import React from 'react';
import { Button, Grid, Grid2, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import PropTypes from 'prop-types';

/**
 * A custom MUI Tooltip Component that is used to display information.
 *
 * @param {string} title - The title of the tooltip.
 *
 * @param {string} description - The description of the tooltip.
 *
 * @param {object} wrapAround - The component to wrap the tooltip around. IE a <Button> or <Icon>.
 *
 * @param {string} placement - The placement of the tooltip. Options are "top", "right", "bottom", "left", "top-start", "right-start", "bottom-start", "left-start", "top-end", "right-end", "bottom-end", "left-end".
 *
 */

export const CinchTooltip = props => {
  const LightTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#fff',
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 14,
      maxWidth: '312px',
      borderRadius: '16px',
      padding: '12px',
      lineHeight: '16px'
    }
  }));
  return <LightTooltip title={<Grid2 container>
          <Grid2 item>
            <Typography variant="caption" sx={{
        fontWeight: 'bold'
      }}>
              {props.title}
            </Typography>
            <br />
            <Typography variant="caption" sx={{
        textAlign: 'justify'
      }}>
              {props.description}
            </Typography>
            <br />
            <br />
          </Grid2>
        </Grid2>} placement={props.placement || 'top-start'}>
      {props.wrapAround}
    </LightTooltip>;
};
CinchTooltip.propTypes = {
  /**
   * The title of the tooltip.
   */
  title: PropTypes.string.isRequired,
  /**
   * The description of the tooltip.
   */
  description: PropTypes.string.isRequired,
  /**
   * The component to wrap the tooltip around. IE a <Button> or <Icon>.
   */
  wrapAround: PropTypes.element.isRequired,
  /**
   * The placement of the tooltip
   */
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'top-start', 'right-start', 'bottom-start', 'left-start', 'top-end', 'right-end', 'bottom-end', 'left-end'])
};
CinchTooltip.defaultProps = {
  placement: 'top-start'
};